import { format, formatDistanceToNow } from 'date-fns'

export function normalizeUTCTimeFromLocalTz() {
  return format(new Date(), 'yyyy-MM-dd') + 'T00:00:00Z'
}

export function timeAgo(dateISOString) {
  const date = new Date(dateISOString)
  return formatDistanceToNow(date, { addSuffix: true })
}
